<template>
    <div class="notify" v-if="activity">
        <Banner />
        <div class="notify-wrap" v-html="activity.hint"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Banner from '@/components/Common/banner';
export default {
    data() {
        return {
            backgroundUrl: null,
            activity: null,
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
    },
    components: {
        Banner,
    },
    created() {
        const { activity } = this.defaultInfo;
        this.activity = activity;
    },
    components: { Banner },
};
</script>
<style lang="scss" scoped>
.notify {
    .notify-wrap {
        padding: 24px;
    }
}
</style>